import { create } from "zustand";
import { persist, createJSONStorage } from 'zustand/middleware'

const useRegionalStore = create( persist( (set) => ({
  province: "",
  regency : "",
  district : "",
  addprovince: (province) => set({province : province}),
  addregency: (regency) => set({regency : regency}),
  adddistrict: (district) => set({district: district}),
  reset : () => set({
    province:"",
    regency: "",
    district: ""
  }),
  delprovince : () => set({province : ""}),
  delregency : () => set({regency : ""}),
  deldistrict: () => set({district : ""})
}),{
      name: 'fish-storage', // unique name for localStorage key
      storage: createJSONStorage(() => localStorage), // (optional) default is localStorage
      // partializing: () => ({ fishes: ... }) // optional: only save certain fields
    }))

export default useRegionalStore;